namespace $.$$ {

	$.$shm_hitalama_compat_fqn_install( $ as any )

	export class $shm_dashboard_app extends $.$shm_dashboard_app {

		visit_logged = false
		navigation_section_logged = ''
		navigation_task_logged = ''

		telemetry_auto() {
			this.$.$shm_dashboard_telemetry_sentry.start()
			const authenticated = this.authenticated()
			const user_id = authenticated ? this.$.$shm_ba_pb.user_id() : ''
			this.$.$shm_dashboard_telemetry_sentry.context_update({
				version: this.Menu_page().version_data_version(),
				user_id,
				section: this.app_section(),
				dashboard_id: this.dashboard_id() || '',
			})
			return null
		}

		auth_token() {
			return this.$.$mol_state_local.value< string >( this.$.$shm_pb.auth_store_key( 'token' ) ) || ''
		}

		authenticated() {
			return this.$.$shm_ba_pb.authenticated()
		}

		title() {
			if( !this.authenticated() ) return 'Мониторинг+'

			if( this.app_section() === 'wordstat' ) {
				if( !this.wordstat_task_id() ) return 'Wordstat'
				return this.Wordstat_dashboard().tab_title()
			}

			if( this.app_section() === 'mentions' ) {
				return `${ this.dashboard_title_current() } Мониторинг упоминаний`
			}

			if( this.app_section() === 'mention_stats' ) {
				if( !this.mention_stats_task_id() ) return 'Статистика упоминаний'
				return this.Mention_stats_task().task_title() || 'Статистика упоминаний'
			}

			if( this.app_section() === 'agent' ) return 'М+ Агент'

			return 'Мониторинг+'
		}

		login_url() {
			const location = this.$.$mol_dom_context.location
			const local = location.pathname.includes( '/shm/dashboard/app/-/' )
			const page = location.pathname.endsWith( '/test.html' ) ? 'test.html' : 'index.html'
			const login = local ? `/shm/dashboard/login/-/${ page }` : '/login/'
			const back = `${ location.pathname }${ location.search }${ location.hash }`
			return `${ login }?return=${ encodeURIComponent( back ) }`
		}

		auth_route_auto() {
			const token = this.auth_token()
			if( token && this.$.$shm_ba_pb.auth_valid( token ) !== false ) return null

			this.$.$mol_dom_context.location.replace( this.login_url() )
			return null
		}

		dev_mode() {
			return this.$.$mol_state_arg.value( 'dev_mode' ) === 'true'
		}

		@ $mol_action
		log_visit() {
			if( this.visit_logged ) return null
			if( !this.authenticated() ) return null
			if( !this.$.$shm_ba_pb.user_id() ) return null

			this.visit_logged = true
			return this.$.$shm_ba_pb.log_event( 'visit' )
		}

		log_visit_auto() {
			return this.log_visit()
		}

		@ $mol_action
		navigation_log( section: string, task: string ) {
			if( !this.authenticated() || !this.$.$shm_ba_pb.user_id() ) return null

			if( section === 'mentions' || section === 'wordstat' ) {
				if( this.navigation_section_logged !== section ) {
					this.navigation_section_logged = section
					this.$.$shm_ba_pb.log_event( `section:${ section }` )
				}
			}

			if( section !== 'wordstat' ) {
				this.navigation_task_logged = ''
				return null
			}

			if( task && this.navigation_task_logged !== task ) {
				this.navigation_task_logged = task
				this.$.$shm_ba_pb.log_event( `wordstat_task:${ task }` )
			}
			return null
		}

		navigation_log_auto() {
			const section = this.app_section()
			const task = section === 'wordstat' ? this.wordstat_task_id() : ''
			return this.navigation_log( section, task )
		}

		@ $mol_mem
		chart_animation_initial( next?: number ) {
			const fallback = this.$.$shm_echarts_settings_store.duration_initial()
			const value = next ?? Number( this.$.$shm_ba_pb.user_setting( 'chart_animation_initial_ms', undefined, fallback ) )
			return this.$.$shm_echarts_settings_store.duration_initial_runtime( value )
		}

		@ $mol_mem
		chart_animation_update( next?: number ) {
			const fallback = this.$.$shm_echarts_settings_store.duration_update()
			const value = next ?? Number( this.$.$shm_ba_pb.user_setting( 'chart_animation_update_ms', undefined, fallback ) )
			return this.$.$shm_echarts_settings_store.duration_update_runtime( value )
		}

		@ $mol_action
		chart_animation_initial_save( next?: Event ) {
			if( next === undefined ) return null
			this.$.$shm_ba_pb.user_setting( 'chart_animation_initial_ms', this.chart_animation_initial(), 300 )
			return next
		}

		@ $mol_action
		chart_animation_update_save( next?: Event ) {
			if( next === undefined ) return null
			this.$.$shm_ba_pb.user_setting( 'chart_animation_update_ms', this.chart_animation_update(), 300 )
			return next
		}

		chart_animation_easing( next?: string ) {
			const fallback = this.$.$shm_echarts_settings_store.easing()
			const value = String( this.$.$shm_ba_pb.user_setting( 'chart_animation_easing', next, fallback ) )
			return this.$.$shm_echarts_settings_store.easing_runtime( value )
		}

		chart_settings_sync() {
			if( !this.authenticated() ) return null
			this.chart_animation_initial()
			this.chart_animation_update()
			this.chart_animation_easing()
			return null
		}

		app_pages() {
			this.$.$shm_hitalama_process.result_store_enabled = false

			if( this.authenticated() ) {
				if( this.agent_tab_enabled() && this.app_section() === 'agent' ) return [
					this.Menu_page(),
					this.Agent_app(),
				]
				if( this.mention_stats_enabled() && this.app_section() === 'mention_stats' ) return [
					this.Menu_page(),
					this.Mention_stats_tasks(),
					this.mention_stats_task_id() ? this.Mention_stats_task() : null,
				].filter( Boolean ) as $mol_view[]
				if( this.app_section() === 'settings' ) return [ this.Menu_page(), this.Settings_page() ]
				if( this.dev_mode() && this.app_section() === 'docs' ) return [ this.Menu_page(), this.Documentation() ]
				if( this.wordstat_enabled() && this.app_section() === 'wordstat' ) {
					const task_id = this.wordstat_task_id()
					return [
						this.Menu_page(),
						this.Wordstat_tasks(),
						task_id ? this.Wordstat_dashboard() : this.Wordstat_catalog(),
					].filter( Boolean ) as $mol_view[]
				}
			}

			return this.authenticated()
				? [
					this.Menu_page(),
					this.monitoring_only() ? null : this.Dashboard_list(),
					this.agent_enabled() && this.agent_opened() ? this.Agent_panel() : null,
					this.Dashboard(),
				].filter( Boolean ) as $mol_view[]
				: []
		}

		app_section() {
			const requested = this.$.$mol_state_arg.value( 'section' ) ?? 'mentions'
			if( requested === 'mentions' && !this.mentions_enabled() ) {
				if( this.wordstat_enabled() ) return 'wordstat'
				if( this.mention_stats_enabled() ) return 'mention_stats'
				return 'settings'
			}
			if( requested === 'wordstat' && !this.wordstat_enabled() ) return this.mentions_enabled() ? 'mentions' : 'settings'
			if( requested === 'mention_stats' && !this.mention_stats_enabled() ) return this.mentions_enabled() ? 'mentions' : 'settings'
			if( requested === 'agent' && !this.agent_tab_enabled() ) return this.mentions_enabled() ? 'mentions' : 'settings'
			return requested
		}

		wordstat_enabled() {
			return this.$.$shm_ba_pb.user_wordstat_enabled()
		}

		mentions_enabled() { return this.$.$shm_ba_pb.user_mentions_enabled() }
		mention_stats_enabled() { return this.$.$shm_ba_pb.user_mention_stats_enabled() }
		agent_tab_enabled() { return this.$.$shm_ba_pb.user_agent_enabled() }

		monitoring_only() {
			return this.mentions_enabled() && !this.wordstat_enabled() && !this.mention_stats_enabled() && !this.agent_tab_enabled()
		}

		mention_stats_task_id( next?: string ) {
			if( next !== undefined ) this.$.$mol_state_arg.value( 'mention_stats_task', next || null )
			return this.$.$mol_state_arg.value( 'mention_stats_task' ) || ''
		}

		wordstat_task_id( next?: string ) {
			if( next !== undefined ) {
				this.$.$mol_state_arg.value( 'wordstat_task', next || null )
				return next
			}

			const id = this.$.$mol_state_arg.value( 'wordstat_task' ) ?? ''
			if( !id || id === 'new' ) return ''
			if( !this.Wordstat_tasks().tasks().some( ( task: $shm_wordstat_task_info )=> task.id === id ) ) return ''
			return id
		}

		wordstat_task_title( next?: string ) {
			return this.Wordstat_tasks().task_title_current( next )
		}

		search_mode( next?: string ) {
			return this.Dashboard().search_mode( next )
		}

		search_case_sensitive( next?: boolean ) {
			return this.Dashboard().search_case_sensitive( next )
		}

		version_supported( version: string, min: string ) {
			const current = version.split( '.' ).map( value => Number( value ) || 0 )
			const required = min.split( '.' ).map( value => Number( value ) || 0 )
			const length = Math.max( current.length, required.length )

			for( let index = 0; index < length; index++ ) {
				const left = current[ index ] ?? 0
				const right = required[ index ] ?? 0
				if( left !== right ) return left > right
			}

			return true
		}

		agent_version_supported() {
			return this.version_supported( this.Menu_page().Footer().version(), this.agent_min_version() )
		}

		@ $mol_mem
		agent_enabled( next?: boolean ) {
			if( next !== undefined ) {
				if( !this.agent_version_supported() ) {
					this.agent_opened( false )
					return false
				}
				this.$.$shm_ba_pb.user_agent_enabled( next )
				if( !next ) this.agent_opened( false )
				return next
			}
			if( !this.agent_version_supported() ) return false
			return this.$.$shm_ba_pb.user_agent_enabled()
		}

		@ $mol_mem
		agent_opened( next?: boolean ) {
			if( next !== undefined ) {
				const value = this.agent_version_supported() && this.agent_enabled() ? next : false
				this.$.$mol_state_local.value( 'hitalama_ba_agent_opened', value )
				if( value ) this.agent_prompt_focus_later()
				else this.$.$mol_state_arg.value( 'thinking', null )
				return value
			}
			if( !this.agent_version_supported() ) return false
			if( !this.agent_enabled() ) return false
			return this.$.$mol_state_local.value< boolean >( 'hitalama_ba_agent_opened' ) ?? false
		}

		@ $mol_action
		agent_prompt_focus_later() {
			new this.$.$mol_after_frame( ()=> this.agent_prompt_focus() )
		}

		agent_prompt_focus() {
			if( !this.agent_enabled() || !this.agent_opened() ) return
			this.Agent_page().dom_tree()
			this.Agent_page().Prompt().Edit().focused( true )
		}

		@ $mol_action
		wordstat_queries_focus( next?: Event ) {
			if( next === undefined ) return null
			new this.$.$mol_after_frame( ()=> this.wordstat_queries_focus_now() )
			return next
		}

		wordstat_queries_focus_now() {
			const queries = this.Wordstat_dashboard().Collect_page().Queries()
			queries.dom_tree()
			queries.Edit().focused( true )
		}

		dashboard_title_current() {
			return this.dashboard_model()?.title() ?? 'BA'
		}

		docs_text() {
			return this.$.$mol_fetch.text( 'shm/ba/readme.md' )
		}

		settings_rows() {
			return [
				... this.dev_mode()
					? [
						this.Search_settings(),
						this.User_settings(),
					]
					: [],
				this.Chart_settings(),
				this.File_store_list(),
			]
		}

	}

}
